import { filterXSS } from 'xss';
import React from 'react';

export const styleOfTitle = {
  position: 'absolute',
  // top: '0.875rem',
  width: '28%',
  height: '2.75rem',
  lineHeight: '2.75rem',
  left: '4rem',
  zIndex: 2,
  backgroundColor: 'rgb(51,54,57)',
  fontWeight: 500,
  color: 'white',
  textAlign: 'left',
};

const downloadStyle = {
  ...styleOfTitle,
  left: undefined,
  width: '3.125rem',
  right: '6.75rem',
  textAlign: 'center',
  backgroundColor: 'transparent',
};

const zoomedTitleStyle = {
  ...styleOfTitle,
  height: '4.375rem',
  lineHeight: '4.375rem',
  left: '4.6875rem',
  fontSize: '1rem',
};

const zoomedDownloadStyle = {
  ...downloadStyle,
  top: 0,
  height: '4.375rem',
  lineHeight: '4.375rem',
  right: '7rem',
  fontSize: '1.25rem',
};
const zoomedDownloadCycleStyle = {
  height: '2.8125rem',
  width: '2.8125rem',
};

export const PDFTitle = ({ pdfContent = {}, style, zoomed = false }) => (
  <div
    className="text-ellipsis "
    style={{ ...(zoomed ? zoomedTitleStyle : styleOfTitle), ...style }}
  >
    {pdfContent.fileName || ''}
  </div>
);

export const PDFDownload = ({
  pdfContent = {},
  style = {},
  zoomed = false,
}) => {
  const onDownload = async () => {
    const a = document.createElement('a');
    // document.body.appendChild(a);
    let url;
    if (pdfContent.contentBlob instanceof Blob) {
      url = window.URL.createObjectURL(pdfContent.contentBlob || []);
    } else {
      const res = await fetch(
        `data:application/pdf;base64,${pdfContent.contentBlob}`,
      );
      url = window.URL.createObjectURL((await res.blob()) || []);
    }
    a.href = filterXSS(url);
    a.download = pdfContent.fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div
      className="download-btn-on-pdf-viewer"
      style={{
        ...(zoomed ? zoomedDownloadStyle : downloadStyle),
        ...style,
      }}
    >
      <div onClick={onDownload} style={zoomed ? zoomedDownloadCycleStyle : {}}>
        <span
          className="appkiticon icon-download-fill"
          style={{ fontSize: '1rem' }}
        />
      </div>
    </div>
  );
};
